import { defineStore } from "pinia";
import { ref, useNuxtApp } from "#imports";
import type { R3HTTPResponse } from "@r3shared/types/http";
import type {
	AtualizarDiretrizesRequest,
	AtualizarDiretrizesResponse
} from "@r3shared/types/WMS/MODU_DIRETRIZES/atualizaDiretrizes.types";
import type { Diretrizes } from "@r3shared/types/WMS/MODU_DIRETRIZES/diretrizes.types";
import type { E202SearchResponse } from "@r3shared/types/WMS/MODU_DIRETRIZES/E202_search.types";
import type { E211Search } from "@r3shared/types/WMS/MODU_DIRETRIZES/E211_search.types";
import type { E212SearchResponse } from "@r3shared/types/WMS/MODU_DIRETRIZES/E212_search.types";
import type { E215Search } from "@r3shared/types/WMS/MODU_DIRETRIZES/E215_search.types";
import type { E226TipoUnidade } from "@r3shared/types/WMS/MODU_DIRETRIZES/E226_tipoUnidade.types";
import type {
	E577Response
} from "@r3shared/types/WMS/MODU_COLETOR/E577/E577.types";


export interface DiretrizDataMap {
	"E202": E202SearchResponse;
	"E211": E211Search;
	"E212": E212SearchResponse;
	"E215": E215Search;
	"E226": E226TipoUnidade;
	"E577": E577Response;
}

export type DiretrizNome = keyof DiretrizDataMap


export const useDiretrizesStore = defineStore("diretrizesStore", () => {

	const { $r3fetchdata } = useNuxtApp();
	// const diretrizes = reactive<Diretrizes>({} as Diretrizes);
	const diretrizes = ref<Array<{ name: string, data: object }>>([]);

	// TODO toda vez que criar diretrizes, atualizar o valor em Diretrizes
	// function atualizarDiretriz<K extends keyof Diretrizes>(key: K, value: Diretrizes[K]) {
	//   diretrizes[key] = value;
	// }
	// Funções para altera o valor

	async function atualizarDiretrizes(params: string[]) {

		const userStore = useUserStore();

		const res = await $r3fetchdata.get<
			R3HTTPResponse<AtualizarDiretrizesResponse>, AtualizarDiretrizesRequest
		>("/api/modu_diretrizes/atualizardiretrizes", {
			params: {
				diretrizes: params,
				Empresa: userStore.companyID!
			}
		});

		res.response.forEach(item => {
			// if (diretrizes.value.length > 0) {

			// 	const aux = diretrizes.value.find(dir => dir.name === item.name)
			// 	if (aux) {
			// 		aux.data = item.data;
			// 		diretrizes.value.push(aux!)
			// 	} else {
			// 		diretrizes.value.push({ name: "", data: {} })
			// 	}
			// } else {
			// 	diretrizes.value.push(item)
			// }
			if (diretrizes.value.length > 0) {
				const index = diretrizes.value.findIndex(dir => dir.name === item.name);
				if (index >= 0) {
					// Atualiza a diretriz existente
					diretrizes.value[index].data = item.data;
				} else {
					// Adiciona a nova diretriz ao array
					diretrizes.value.push(item);
				}
			} else {
				diretrizes.value.push(item);
			}
		});

	}

	/**
	 * Função para obter os campos da diretriz buscada
	 * @todo Sempre lembrar de adicionar o par chave-valor da diretriz na interface
	 * @param diretriz Diretriz procurada
	 * @returns O valor do tipo da diretriz
	 */
	const getDiretriz = <K extends DiretrizNome>(diretriz: K): Readonly<DiretrizDataMap[K]> | undefined => {
		const diretrizBuscada = diretrizes.value.find(d => d.name === diretriz);
		if (diretrizBuscada) {
			return diretrizBuscada.data as Readonly<DiretrizDataMap[K]>
		}

		return undefined;
	};

	return {
		diretrizes,
		atualizarDiretrizes,
		getDiretriz
	}
})



